module.exports = __webpack_public_path__ + "img/codelog.679a10ec.png";